import { Select, SelectProps } from 'antd';
import {
  useInvoiceGovermentPresumedCodeDetail,
  useInvoiceGovermentPresumedCodeList,
} from '@/core/domain/invoice/government/goverment.hooks';
import { InvoiceGovernmentPresumedCode } from '@/core/domain/invoice/government/government.types';
import { useMemo } from 'react';

interface Props extends SelectProps {
  queryEnabled?: boolean;
}

export default function SelectInvoicePresumedCode({
  queryEnabled,
  ...props
}: Props) {
  const presumedList = useInvoiceGovermentPresumedCodeList(queryEnabled);
  const presumedDetail = useInvoiceGovermentPresumedCodeDetail(props.value);

  const list = presumedList.data || [];

  const getPresumedLabel = (item: InvoiceGovernmentPresumedCode) =>
    `${item.code} - ${item.description}`;

  const options = useMemo(() => {
    const items = list.map((item) => ({
      value: String(item.code),
      label: getPresumedLabel(item),
    }));

    if (items.some((item) => item.value === props.value)) return items;

    if (presumedDetail.data)
      return [
        {
          value: String(presumedDetail.data?.code),
          label: getPresumedLabel(presumedDetail.data),
        },
        ...items,
      ];

    return items;
  }, [list, presumedDetail.dataUpdatedAt, props.value]);

  return (
    <Select
      {...props}
      options={options}
      loading={presumedList.isLoading}
      showSearch
      optionFilterProp="label"
    />
  );
}
